import React from 'react';
import { connect } from 'react-redux';
import Divider from 'antd/lib/divider';
import 'antd/lib/divider/style/index.css';
import Col from 'antd/lib/grid/col';
import Row from 'antd/lib/grid/row';
import 'antd/lib/grid/style/index.css';
import Icon from 'antd/lib/icon';
import Layout from 'antd/lib/layout';
import 'antd/lib/layout/style/index.css';
import List from 'antd/lib/list';
import 'antd/lib/list/style/index.css';
import FaInstagram from 'react-icons/lib/fa/instagram';
var selfStyles = require('./styles.scss');
var crimpLogo = require('src/assets/logo/favicon-64.png');
var PageFooter = function (props) {
    var event = props.workspaceMain.event;
    return (React.createElement(Layout.Footer, { className: selfStyles.footer },
        React.createElement(Row, { gutter: 48, className: selfStyles.footerRow },
            event && (React.createElement(Col, { xs: { span: 24 }, md: { span: 12, push: 12 }, className: selfStyles.footerColumn },
                React.createElement("div", { className: selfStyles.brand, style: { justifyContent: 'center' } },
                    React.createElement("div", { className: selfStyles.brandName }, event.name)),
                (event.logoUrl || event.logoIdenticon) &&
                    React.createElement("div", { className: selfStyles.event },
                        React.createElement("img", { src: event.logoUrl || event.logoIdenticon, className: selfStyles.eventLogo, alt: event.name })),
                event.description &&
                    React.createElement("pre", { className: selfStyles.eventDescription }, event.description),
                React.createElement(Divider, null),
                event.website &&
                    React.createElement("a", { href: event.website, target: '_blank' },
                        React.createElement(Icon, { type: 'link' }),
                        "  Event website"))),
            React.createElement(Col, { xs: { span: 24 }, md: { span: 12, pull: 12 }, className: selfStyles.footerColumn },
                React.createElement("div", { className: selfStyles.brand },
                    React.createElement("img", { src: crimpLogo, className: selfStyles.brandLogo, alt: 'CRIMP' }),
                    React.createElement("div", { className: selfStyles.brandName },
                        process.env.REACT_APP_DEPLOY_ENV === 'staging'
                            ? 'PINCH'
                            : process.env.REACT_APP_DEPLOY_ENV === 'production'
                                ? 'CRIMP'
                                : 'CRIMP.',
                        process.env.NODE_ENV === 'development' && React.createElement("small", null, "dev"))),
                React.createElement("p", null, "CRIMP is the ultimate automated scoring solution for climbing events. We simplify the scorekeeping process for the event organizers, help judges work better, and deliver live scores to the climbers and spectators to supercharge their event experience."),
                React.createElement("p", null, "We are battle-tested - from small youth team practices to huge 800 climbers multi-day events, we have handled them easily. If we're an anchor, we'll be SERENE and bomber."),
                React.createElement("p", null,
                    "Still using clipboards and Excel to record scores? We can do better. ",
                    React.createElement("a", { href: "//crimp.rocks/?ref=spec_footer", target: "_blank" }, "Try us out for free!")),
                React.createElement(Divider, null),
                React.createElement("p", null,
                    "Did you find a bug? Or have a suggestion?",
                    React.createElement("br", null),
                    "Talk to us! We would love to hear from you!"),
                React.createElement(List, { size: 'small', bordered: false, split: false, renderItem: function (item) { return (React.createElement(List.Item, null,
                        React.createElement("a", { href: item.href, className: selfStyles.footerList },
                            item.icon,
                            "  ",
                            item.text))); }, dataSource: [
                        { icon: React.createElement(Icon, { type: 'mail' }), href: 'mailto:hello@crimp.rocks', text: 'hello@crimp.rocks' },
                        { icon: React.createElement(Icon, { type: 'facebook' }), href: 'https://www.facebook.com/CRIMP.rocks/', text: 'CRIMP.rocks' },
                        { icon: React.createElement(FaInstagram, null), href: 'https://www.instagram.com/crimp.rocks/', text: 'CRIMP.rocks' },
                    ] })))));
};
var mapStateToProps = function (state) { return ({
    workspaceMain: {
        event: state.workspaceEvent.event && state.workspaceEvent.event.data[0],
    },
}); };
export default connect(mapStateToProps)(PageFooter);



//////////////////
// WEBPACK FOOTER
// ./src/pages/templates/components/PageFooter/index.tsx
// module id = 215
// module chunks = 0